/*
 * <cart-fx-rate> — mirrors Shopify's live exchange rate into hidden cart
 * attributes (`_fx_rate`/`_fx_currency`) so server-rendered Liquid
 * (cart-rewards-bar) can convert its shop-currency thresholds into the
 * presentment currency.
 *
 * Liquid exposes no FX rate. window.Shopify.currency.rate (undocumented but
 * long-stable; the same current rate Shopify uses to convert a discount's own
 * minimum amount at checkout) is the storefront's only source. When the active
 * currency differs from the shop currency and the stored attributes are missing
 * or stale, they are written via /cart/update.js and the drawer re-renders with
 * converted thresholds. In shop-currency mode this is a no-op; at most one cart
 * write happens per pageview.
 *
 * Mounted once outside #CartDrawer so it survives cart re-renders. Uses the
 * same routes + fetchConfig + pub/sub as the rest of Dawn.
 */
class CartFxRate extends HTMLElement {
  connectedCallback() {
    const fx = window.Shopify && window.Shopify.currency;
    if (!fx || !fx.active || !fx.rate) return;
    if (fx.active === this.dataset.shopCurrency) return;
    if (this.dataset.storedCurrency === fx.active && this.dataset.storedRate === fx.rate) return;
    this.store(fx);
  }

  async store(fx) {
    try {
      const response = await fetch(routes.cart_update_url, {
        ...fetchConfig(),
        body: JSON.stringify({
          attributes: { _fx_rate: fx.rate, _fx_currency: fx.active },
          sections: ['cart-drawer'],
          sections_url: window.location.pathname,
        }),
      });
      const parsed = await response.json();
      const html = parsed.sections && parsed.sections['cart-drawer'];
      const target = document.querySelector('#CartDrawer .drawer__inner');
      if (html != null && target) {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
        if (fresh) target.innerHTML = fresh.innerHTML;
      }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-fx-rate', cartData: parsed });
    } catch (e) {
      // non-critical: the bar stays hidden until the next pageview retries.
    }
  }
}

customElements.define('cart-fx-rate', CartFxRate);
